import { createSelector } from 'reselect';
import { createAction } from '@mews/framework';
import { getStringProp } from '@mews/fp';
import { createScopedReducer, createPrefixer } from '@mews-commander/utils';

import parentSelector from '../selector';

export const NAME = 'simpleDetail';
const prefix = createPrefixer(NAME);

export const SIMPLE_DETAIL_GROUP = 'simpleDetailGroup';
export const SIMPLE_DETAIL_RESERVATION = 'simpleDetailReservation';

const GROUP_SELECTED = prefix('GROUP_SELECTED');
const RESERVATION_SELECTED = prefix('RESERVATION_SELECTED');

export default createScopedReducer(
    { mode: SIMPLE_DETAIL_RESERVATION },
    {
        [GROUP_SELECTED]: (state: $TSFixMe) => ({
            ...state,
            mode: SIMPLE_DETAIL_GROUP,
        }),

        [RESERVATION_SELECTED]: (state: $TSFixMe) => ({
            ...state,
            mode: SIMPLE_DETAIL_RESERVATION,
        }),
    }
);

export const showGroup = (groupId: $TSFixMe, scope: $TSFixMe) => createAction(GROUP_SELECTED, undefined, { scope });
export const showReservation = (reservationId: $TSFixMe, scope: $TSFixMe) =>
    createAction(RESERVATION_SELECTED, undefined, { scope });

const moduleSelector = createSelector(parentSelector, (state) => state[NAME]);

const getSimpleDetail = createSelector(moduleSelector, getStringProp('scope'), (state, scope) => state[scope] || {});

export const getSimpleDetailMode = createSelector(getSimpleDetail, (state) => state.mode);
